import { useCallback } from 'react';
import { createNavigationHelpers } from '../../../lib/navigationUtils';
import { useNavigationService } from '../../../stores';
import { CalendarView } from '../types/calendarTypes';

export const useHomeNavigation = (
  workspaceSlug: string,
  format: (date: Date, formatStr: string) => string,
  isTrainingMode: boolean,
  trainingIdParam: string | undefined,
  calendarCurrentDate: Date,
  calendarView: CalendarView
) => {
  const navigationService = useNavigationService();

  const { navigateToCalendarView, navigateToDay, navigateToTraining } =
    createNavigationHelpers(workspaceSlug, navigationService, format);

  const handleDateSelect = useCallback(
    (date: Date) => {
      navigateToDay(date, false);
    },
    [navigateToDay]
  );

  const handleCalendarViewChange = useCallback(
    (view: CalendarView) => {
      if (isTrainingMode) {
        navigateToTraining(trainingIdParam!);
        return;
      }
      navigateToCalendarView(view, calendarCurrentDate, false);
    },
    [
      isTrainingMode,
      trainingIdParam,
      navigateToTraining,
      navigateToCalendarView,
      calendarCurrentDate,
    ]
  );

  const handleCalendarDateChange = useCallback(
    (date: Date) => {
      navigateToCalendarView(calendarView, date, true);
    },
    [navigateToCalendarView, calendarView]
  );

  const handleTimeSlotClick = useCallback(
    (date: string, trainingId: string) => {
      navigateToTraining(trainingId);
    },
    [navigateToTraining]
  );

  return {
    handleDateSelect,
    handleCalendarViewChange,
    handleCalendarDateChange,
    handleTimeSlotClick,
  };
};
